import { InvestorIcon } from 'assets/svg/sidebarIcons';

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const crm = {
  id: 'crm',
  title: '',
  type: 'group',
  children: [
    {
      id: 'crm-leads',
      title: 'CRM',
      type: 'item',
      url: '/crm',
      icon: InvestorIcon,
      allowedRoles: ['admin', 'superAdmin', 'complianceOfficer', 'marketingSpecialist'],
      breadcrumbs: false
    }
  ]
};

export default crm;
